import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Paper, Typography } from '@popmenu/common-ui';
import { Heart } from '@popmenu/web-icons';
import { makeStyles } from '../../../utils/withStyles';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.surface.dark,
    color: theme.palette.getContrastText(theme.palette.surface.dark),
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  link: {
    color: theme.palette.getContrastText(theme.palette.surface.dark),
    textDecoration: 'none',
  },
}));

export const Footer = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Paper className={classes.container} component="footer" elevation={0} square>
      <Typography>
        <a
          className={classes.link}
          href="https://get.popmenu.com"
          rel="noopener"
          target="_blank"
        >
          <FormattedMessage
            defaultMessage="Made with {icon} by Popmenu"
            values={{
              icon: <Icon aria-label={intl.formatMessage({ defaultMessage: 'love' })} icon={Heart} />,
            }}
          />
        </a>
      </Typography>
    </Paper>
  );
};
